import http from './common/http-service';
import axios from 'axios';
import { Err, Ok } from 'ts-results';
export class ResourceSearchService {
    async PostRequest(searchRequest) {
        try {
            const { data, status } = await http.post('/resources', searchRequest);
            return data;
        }
        catch (error) {
            return CatchError(error);
        }
    }
    async Get(id) {
        try {
            const { data, status } = await http.get('/resources/' + id);
            return Ok(data);
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                return Err('error message: ' + error.message);
            }
            return Err('unexpected error: ' + error);
        }
    }
}
function CatchError(error) {
    if (axios.isAxiosError(error)) {
        console.log('error message: ', error.message);
    }
    else {
        console.log('unexpected error: ', error);
    }
    return {
        categories: [],
        items: [],
        limit: 0,
        offset: 0,
        resourceTypeSummary: {
            vector: 0,
            raster: 0,
            table: 0,
            notebook: 0,
            application: 0,
            scenario: 0,
        },
        total: 0,
    };
}
